import { Pipe, PipeTransform } from "@angular/core";
import { IUserCrud } from "../interfaces/ilogin";

/**
 * Filters the items based toggle switch state and filter
 */
@Pipe({
    name: "usersfilter",
    standalone: true
})
export class UsersFilterPipe implements PipeTransform {
    transform(users: IUserCrud[], searchTerm: string): any {
        if (!searchTerm || searchTerm.length === 0) {
            return users;
        }
        const st: string = searchTerm.toLowerCase();

        if (!users) {
            return users;
        }
        return users.filter(
            (item: IUserCrud) => {
                return item.userName.toLowerCase().indexOf(st) > -1 ||
                    item.email.toLowerCase().indexOf(st) > -1 ||
                    item.companyName.toLowerCase().indexOf(st) > -1
                    || (`${item.firstName} ${item.lastName}`).toLowerCase().indexOf(st) > -1;
            });
    }
}

